import { createSelector } from './selectorWrapper'
import { simpleSelectors } from './basicState'
import { ICollection, sanitizeCollections } from './collections'
import { TitleIdToCarousel } from '../reducers/carousel'
import { IFatal } from '../components/error/withFatalCheck'

export type ISanitizedCarousel = (ICollection | IFatal | null)[]

export const sanitizedCarouselSelector = createSelector(
  simpleSelectors.pageTitleId,
  simpleSelectors.carousel,
  (
    pageTitleID: string,
    titleIdToCarousel: TitleIdToCarousel
  ): ISanitizedCarousel => {
    return sanitizeCollections(titleIdToCarousel[pageTitleID])
  }
)
